export const apiCreate = (): string => '/warehouse/unitTypes/'
export const apiList = (id?: string): string =>
  !id ? '/warehouse/unitTypes/' : `/warehouse/unitTypes/view/${id}`
export const apiUpdate = (id: string): string =>
  `/warehouse/unitTypes/update/${id}`
export const apiDelete = (id: string): string => `/warehouse/unitTypes/${id}`
